import styles from "../../common/SubscribeComp/Subscribe.module.scss";
import React, { useState } from "react";
import { errorMessages } from "@/utils/constants";
import { checkIfEmail } from "@/helpers/generalHelper";
import { client } from "@/utils/netlify";
import { reportError } from "@/helpers/errorHelper";
import InputField from "@/components/common/CommonInputComponent";

export default function SubscribeComp() {
  const [emailErrorMessage, setEmailErrorMessage] = useState(false);
  const [successMsg, setSuccessMessage] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  let updatedSuccess = errorMessages.newsLetterSignup.successSignup;

  function handleEmailFormat(email) {
    // Check for valid email if valid => processed further , else => Error msg will show.
    if (email) {
      var validEmail = checkIfEmail(email);
      if (!validEmail) {
        setEmailErrorMessage(errorMessages.newsLetterSignup.invalidEmail);
        return false;
      } else {
        setEmailErrorMessage(null);
        return true;
      }
    } else {
      setEmailErrorMessage(errorMessages.newsLetterSignup.invalidEmail);
      return false;
    }
  }

  // Newsletter Subscribe Click event
  const handleEmailSubmit = async () => {
    try {
      setLoading(true);
      if (email && handleEmailFormat(email)) {
        // First Remove error/success messages on submit click
        setSuccessMessage("");
        setEmailErrorMessage("");
        // If email is valid then will processed to subscription.
        let data = {
          email: email,
        };
        const getResponse = await client("klaviyo-subscriber-add", data, true);
        setLoading(false);
        if (getResponse.status === 200) {
          /* successfully added email in list  */
          setSuccessMessage(updatedSuccess);
          return;
        }
        if (getResponse.status == 202) {
          /* Invalided email status  */
          setEmailErrorMessage(errorMessages.newsLetterSignup.invalidEmail);
          return;
        }
        if (getResponse.status == 204) {
          /* Already exists email */
          setEmailErrorMessage(
            errorMessages.newsLetterSignup.alreadyRegistered
          );
          return;
        }
        if (getResponse.status == 201) {
          /* Invalided request   */
          setEmailErrorMessage(errorMessages.newsLetterSignup.somethingWrong);
          return;
        }
        if (getResponse.status != 200) {
          /* Unknown Invalided request   */
          setEmailErrorMessage(errorMessages.newsLetterSignup.somethingWrong);
          console.error(
            "Unknown status code in Klaviyo email subscription in the footer section"
          );
          console.error(getResponse.data);
          return;
        }
      }
      setLoading(false);
    } catch (error) {
      reportError("Error in Klaviyo subscribe comp");
      reportError(error);
    }
  };

  return (
    <div className={`${styles.subscribe_wrapper}`}>
      <p className={`normal-md x-small-sm small-xs bold ${styles.discount}`}>
        15% off when you sign up
      </p>
      <p className={`x-small-md xx-small-sm x-small-xs ${styles.message}`}>
        Get the latest Olivela news and offers. When you shop 20% of proceeds
        support causes you care about
      </p>

      <div className={styles["btn-group"]}>
      <InputField
        type="text"
        name="email"
        label="Enter your email"
        placeholder=" "
        autoComplete="email"
        ariaLabel="enter your email. 15% off when you sign up"
        className="x-small-md xx-small-sm x-small-xs"
        onChange={(e) => {
          setEmail(e.currentTarget.value);
          setSuccessMessage("");
        }}
        onBlur={(e) => {
          handleEmailFormat(e.target.value);
        }}
        value={email}
        tabIndex={0}
        subsEmail={true}
        />
        <button
          className={`btn-primary ${loading ? " loading" : ""}`}
          onClick={(e)=>handleEmailSubmit(e)}
          onKeyDown={(e)=>{
            if(e?.key=='Enter'){
              e.preventDefault();
              e.stopPropagation();
              handleEmailSubmit(e)}
            }
          }
          tabIndex={0}
        >
          <span className="ga-subscribe">Subscribe</span>
        </button>
      </div>
      {emailErrorMessage && (
        <span className="error x-small-xs x-small-sm x-small-md form_error">
          {emailErrorMessage}
        </span>
      )}
      {successMsg&&!emailErrorMessage && (
        <span className="x-small-xs x-small-sm x-small-md form_error text-green">
          {updatedSuccess}
        </span>
      )}
    </div>
  );
}
